export default function (req, res) {
    const PUBLIC_URL = process.env.PUBLIC_URL;
    if (
        !PUBLIC_URL ||
        ![
            'https://jblstore.md',
            'https://farmacie.ecom.md',
            'https://italteh.ecom.md',
            'https://casadeltabaco.ecom.md',
            'https://antfarm.ecom.md',
            'https://novaporta.ecom.md',
            'http://localhost:8000'
        ].includes(PUBLIC_URL)
    ) {
        // the old robots.txt other platforms.
        const content = `User-agent: *
        Allow: *
        Sitemap: ${PUBLIC_URL}/sitemap.xml
        `;
        res.end(
            content
                .split('\n')
                .map(line => line.trim())
                .join('\n')
        );
    } else {
        const content = `User-agent: *
        Sitemap: ${PUBLIC_URL}/sitemap.xml

        User-agent: Googlebot
        Sitemap: ${PUBLIC_URL}/sitemap.xml

        User-agent: Yandex
        Host: ${PUBLIC_URL}
        Sitemap: ${PUBLIC_URL}/sitemap.xml
        `;

        res.end(
            content
                .split('\n')
                .map(line => line.trim())
                .join('\n')
        );
    }
}
